import { EventEmitter } from 'events';

class Model extends EventEmitter {
  constructor() {
    super();
    this._currentProject = null;
    this._projects = [];
    this._profile = null;
    this._loading = false;
    this._error = null;

    // Initialize from localStorage if available
    this._initializeFromStorage();
  }

  _initializeFromStorage() {
    try {
      const currentProject = localStorage.getItem('currentProject');
      if (currentProject) {
        this._currentProject = JSON.parse(currentProject);
      }
      
      const projects = localStorage.getItem('projects');
      if (projects) {
        this._projects = JSON.parse(projects);
      }
      
      const profile = localStorage.getItem('profile');
      if (profile) {
        this._profile = JSON.parse(profile);
      }
    } catch (error) {
      console.error('Error initializing from storage:', error);
      this._error = error;
    }
  }

  setCurrentProject(currProject) {
    this._currentProject = currProject;
    localStorage.setItem('currentProject', JSON.stringify(currProject));
    this.emit('projectChanged', currProject);
  }

  getCurrentProject() {
    return this._currentProject;
  }

  setProjects(projects) {
    this._projects = projects;
    localStorage.setItem('projects', JSON.stringify(projects));
    this.emit('projectsUpdated', projects);
  }

  getProjects() {
    return this._projects;
  }

  setProfile(profile) {
    this._profile = profile;
    localStorage.setItem('profile', JSON.stringify(profile));
    this.emit('profileUpdated', profile);
  }

  getProfile() {
    return this._profile;
  }

  setLoading(loading) {
    this._loading = loading;
    this.emit('loadingChanged', loading);
  }

  isLoading() {
    return this._loading;
  }

  setError(error) {
    this._error = error;
    this.emit('error', error);
  }

  getError() {
    return this._error;
  }

  // Helper method to clear all data
  clearData() {
    this._currentProject = null;
    this._projects = [];
    this._profile = null;
    this._error = null;
    localStorage.clear();
    this.emit('dataCleared');
  }
}

export default Model;